<p-toast [style]="{marginTop: '80px'}"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<p-table #pt [value]="orderProducts" [lazy]="true" (onLazyLoad)="loadLazy($event)" dataKey="orderProductId"
  selectionMode="single" [(selection)]="orderProduct" (onRowSelect)="onRowSelect($event)"
  [loading]="loading" [paginator]="true" [rows]="25" [rowsPerPageOptions]="[25,100,200]" showCurrentPageReport="true"
  currentPageReportTemplate="{totalRecords} results. Page {currentPage} of {totalPages}" [totalRecords]="recordTotal"
  sortMode="multiple" [multiSortMeta]="multiSortMeta" styleClass="p-datatable-striped" [ngStyle]="{'width': 'auto'}"
  [resizableColumns]="true" [autoLayout]="true" [responsive]="true" class="order-product-wrapper">

  <ng-template pTemplate="caption">
    <div class="d-block text-end" class="header-button">
      <span>
        <!--clear filters-->
        <button pButton pRipple class="p-button-text"
          style="font-size: 80%; padding: 0.643rem 0.75rem !important; margin-right:10px;"
        (click)="reloadPage()">Clear Filters</button>

        <!--add new-->
        <button pButton pRipple class="p-button btn-blue"
        (click)="onOpenFormAdd()">New Order Product +</button>
      </span>
    </div>
  </ng-template>
  <ng-template pTemplate="header">
    <tr>
      @for (col of columns; track col) {
        <th [pSortableColumn]="col.field" [ngStyle]="{'width': 'auto'}">
          <div class="d-flex flex-wrap position-relative">
            <span >{{col.header}}</span>
            <p-sortIcon class="filterIcon" [field]="col.field"></p-sortIcon>
          </div>
        </th>
      }
      <th [ngStyle]="{'width': 'auto'}"></th>
    </tr>
    <tr>
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'orderProductId', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'name', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'description', 'in')"></th>
      <th [ngStyle]="{'width': '50px'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'listPrice', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'cashPaymentAdjustmentTarget', 'in')"></th>
      <th [ngStyle]="{'width': '90px'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'salesTaxable', 'in')"></th>
      <th [ngStyle]="{'width': '90px'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'roomTaxable', 'in')"></th>
      <th [ngStyle]="{'width': '30px'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'productCode', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'productGroup', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'applyToAllUnit', 'in')"></th>
      <th [ngStyle]="{'width': '100px'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'feeUniquePerUnit', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}">
        <p-dropdown #aa [style]="{'width':'50px','min-width':'100%'}" [options]="feeTypes" appendTo="body"
          (onChange)="pt.filter($event.value, 'feeType', 'in')" styleClass="p-column-filter"
          placeholder="Filter" [showClear]="true" optionLabel="name" optionValue="value">
          <ng-template let-option pTemplate="item">
            <span>{{option.name}}</span>
          </ng-template>
        </p-dropdown>
      </th>
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'active', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'addToRate', 'in')"></th>


      <th [ngStyle]="{'width': 'auto'}">
        <p-dropdown #aa [style]="{'width':'50px','min-width':'100%'}" [options]="feeFrequencies" appendTo="body"
          (onChange)="pt.filter($event.value, 'feeFrequency', 'in')" styleClass="p-column-filter"
          placeholder="Filter" [showClear]="true" optionLabel="name" optionValue="value">
          <ng-template let-option pTemplate="item">
            <span>{{option.name}}</span>
          </ng-template>
        </p-dropdown>
      </th>
      <th [ngStyle]="{'width': 'auto'}"></th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-orderProduct>
    <tr [pSelectableRow]="orderProduct">
      <td>{{orderProduct.orderProductId}} </td>
      <td>{{orderProduct.name}}</td>
      <td>{{orderProduct.description}}</td>
      <td>{{orderProduct.listPrice}}</td>
      <td>{{orderProduct.cashPaymentAdjustmentTarget}}</td>
      <td>{{orderProduct.salesTaxable}}</td>
      <td>{{orderProduct.roomTaxable}}</td>
      <td>{{orderProduct.productCode}}</td>
      <td>{{orderProduct.productGroup}}</td>
      <td>{{orderProduct.applyToAllUnit}}</td>
      <td>{{orderProduct.feeUniquePerUnit}}</td>
      <td>{{getFeeTypesName(orderProduct)}}</td>
      <td>{{orderProduct.active}}</td>
      <td>{{orderProduct.addToRate}}</td>
      <td>{{getFeeFrequencyName(orderProduct)}}</td>
      <td><span style="float:none">
        <a>
          <mat-icon style="color:blue; font-size:110%; padding-right:20px;"
          (click)="onOpenFormEdit(orderProduct)">edit</mat-icon>
        </a>
      </span>
    </td>
  </tr>
</ng-template>
</p-table>